const removeAllExtensions = (fileName: string): string => fileName.replace(/(\.[^./]+)+$/, "")

const normalizeImageKey = (rawPath: string): string => {
  const fileName = rawPath.split("/").pop()

  return fileName ? removeAllExtensions(fileName).toLowerCase() : ""
}

const audienceImageModules = import.meta.glob("../../assets/images/landing/audiences/*", {
  eager: true,
  import: "default",
}) as Record<string, string>

const compareAudienceImageKeys = (first: string, second: string): number => {
  const firstNumber = Number(first)
  const secondNumber = Number(second)
  const firstIsNumber = Number.isFinite(firstNumber)
  const secondIsNumber = Number.isFinite(secondNumber)

  if (firstIsNumber && secondIsNumber) {
    return firstNumber - secondNumber
  }

  if (firstIsNumber) {
    return 1
  }

  if (secondIsNumber) {
    return -1
  }

  return first.localeCompare(second, "pt-BR")
}

const audienceImagesByKey = Object.entries(audienceImageModules).reduce<Record<string, string>>(
  (accumulator, [path, url]) => {
    const key = normalizeImageKey(path)

    if (key) {
      accumulator[key] = url
    }

    return accumulator
  },
  {},
)

export const audienceImages = Object.entries(audienceImagesByKey)
  .sort(([firstKey], [secondKey]) => compareAudienceImageKeys(firstKey, secondKey))
  .map(([key, src]) => ({ key, src }))

export const resolveAudienceImagePath = (imagePath: string): string => {
  const key = normalizeImageKey(imagePath)

  return key ? (audienceImagesByKey[key] ?? imagePath) : imagePath
}
